import React from 'react';
import { View, Text, ViewStyle, TextStyle, StyleSheet } from 'react-native';
import { JobCardInfoModalRowProps } from '@v2/pages/planboard/types';


const JobCardInfoModalRow: React.FC<JobCardInfoModalRowProps> = ({
  label,
  value,
  isLast = false,
  C,
  scale,
  font,
}) => {
  const rowStyle: ViewStyle = {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: scale(10),
    borderBottomWidth: isLast ? 0 : StyleSheet.hairlineWidth,
    borderBottomColor: C('Hairline/Light/No trans [mobile]'),
  };

  const labelStyle: TextStyle[] = [font['Body'], { color: C('Label/Light/Primary') }];
  const valueStyle: TextStyle[] = [font['Body'], { color: C('Label/Light/Tertiary') }];

  return (
    <View style={rowStyle}>
      <Text style={labelStyle}>{label}</Text>
      {typeof value === 'string' || typeof value === 'number' ? <Text style={valueStyle}>{value}</Text> : value}
    </View>
  );
};

export default JobCardInfoModalRow;
